<template>
  <div class="teaching-arrange-schedule-update">
    <DataGridDialog :visible.sync="visible"
                    title="编辑课程"
                    width="960px"
                    custom-class="teaching-arrange-schedule-update-dialog">
      <TeachingArrangeScheduleUpdateMain :visible="visible"
                                         :details="details"
                                         v-bind="$attrs"
                                         :map-key="mapKey"
                                         :circle-radius="circleRadius"
                                         @hidePopover="hidePopover"
                                         @updateSuccess="onUpdateSuccess"></TeachingArrangeScheduleUpdateMain>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
import TeachingArrangeScheduleUpdateMain from './main'
export default {
  name: 'TeachingArrangeScheduleUpdate',
  components: {
    DataGridDialog,
    TeachingArrangeScheduleUpdateMain
  },
  props: {
    mapKey: {
      type: String,
      required: true
    },
    circleRadius: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      visible: false,
      details: null
    }
  },
  methods: {
    showPopover (details) {
      this.details = details
      this.$nextTick(() => {
        this.visible = true
      })
    },
    hidePopover () {
      this.visible = false
    },
    onUpdateSuccess () {
      this.visible = false
      this.$nextTick(() => {
        this.$emit('refresh')
      })
    }
  }
}
</script>

<style lang="scss">
.teaching-arrange-schedule-update-dialog {
  width: 960px;
  max-width: calc(100vw - 48px) !important;
  height: 760px;
  max-height: 88vh;
  margin-top: 6vh !important;
  display: flex;
  flex-direction: column;

  > .el-dialog__header {
    flex: none;
  }

  > .el-dialog__body {
    flex: auto;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
